import { takeLatest } from "redux-saga/effects";

import { defaultReturn, generateDefaultActions, makePayload, requestSaga } from "../utils/helpers";

const initialState = {
  splashScreenMessages: ["Preparing your data, please hold tight"]
};

export const GET_SCREEN_MESSAGES = generateDefaultActions("GET_SCREEN_MESSAGES");
export const getSplashScreenMessages = payload => makePayload(GET_SCREEN_MESSAGES.value, payload);
function* getSplashScreenMessagesSaga() {
  yield requestSaga(GET_SCREEN_MESSAGES, "/getSplashScreenMessages");
}

export default function splashScreenReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SCREEN_MESSAGES.success:
      return defaultReturn(state, payload, "splashScreenMessages");
    default:
      return state;
  }
}

export function* splashScreenSaga() {
  yield takeLatest(GET_SCREEN_MESSAGES.value, getSplashScreenMessagesSaga);
}
